import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import BillingResource from '/@/modules/billing/resources/BillingResource';
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';

export class BillingService extends BaseService {
  /**
   * @var {BillingResource}
   */
  resource;

  constructor() {
    super();

    this.resource = BillingResource;
  }

  /**
   * @returns {Promise<BillingPlan[]>}
   */
  async getAllPlans() {
    return this.resource.getAllPlans();
  }

  /**
   * @returns {Promise<BillingPlan>}
   */
  async getUserPlan() {
    return this.resource.getUserPlan();
  }

  /**
   * @returns {Promise<BillingAddon[]>}
   */
  async getAllAddons() {
    return this.resource.getAllAddons();
  }

  /**
   * @returns {Promise<BillingCoupon[]>}
   */
  async getAllCoupons() {
    return this.resource.getAllCoupons();
  }

  /**
   * @returns {Promise<BillingSubscription>}
   */
  async getUserSubscription() {
    return this.resource.getUserSubscription();
  }

  /**
   * @returns {Promise<BillingInvoice[]>}
   */
  async getUserInvoices() {
    return this.resource.getUserInvoices();
  }

  /**
   * @returns {Promise<BillingAddon[]>}
   */
  async getUserAddons() {
    return this.resource.getUserAddons();
  }

  /**
   * @returns {Promise<BillingCoupon[]>}
   */
  async getUserCoupons() {
    return this.resource.getUserCoupons();
  }

  /**
   * @returns {Promise<BillingPaymentSource[]>}
   */
  async getUserPaymentSources() {
    return this.resource.getUserPaymentSources();
  }

  /**
   * @returns {Promise<BillingCustomer>}
   */
  async getUserCustomer() {
    return this.resource.getUserCustomer();
  }

  /**
   * @param {BillingPaymentSource} paymentSource
   * @returns {Promise<*>}
   */
  async removePaymentSource(paymentSource) {
    return this.resource.removePaymentSource(paymentSource);
  }

  /**
   * @param {string} hostedPageId
   * @returns {Promise<BillingCheckout>}
   */
  async postCheckoutFlow(hostedPageId) {
    return this.resource.postCheckoutFlow(hostedPageId);
  }

  /**
   * @param {string} planId
   * @returns {Promise<BillingCheckout>}
   */
  async getCheckoutUrl(planId) {
    return this.resource.getCheckoutUrl(planId);
  }

  /**
   * @param {string} planId
   * @returns {Promise<BillingCheckout>}
   */
  async getCheckoutExistingUrl(planId) {
    return this.resource.getCheckoutExistingUrl(planId);
  }

  /**
   * @param {string} invoiceId
   * @returns {Promise<void>}
   */
  async downloadInvoice(invoiceId) {
    const download = await this.resource.downloadInvoice(invoiceId);
    return DocumentUIService.openUrl(download.downloadUrl);
  }

  /**
   * @param {*} params
   * @returns {Promise<BillingPlanPrice>}
   */
  async calculateBillingPlanPrices(params) {
    return this.resource.calculateBillingPlanPrices(params);
  }
}

export default new BillingService();
